import { riskSeverityCardClass } from '@/sections/insights/metrics/constants/riskSeverityStyles';
import { RiskSeverity, SeverityDef } from '@/types';
import { cn } from '@/utils/classname';

export function RiskSeverityCard({
  severity,
  label,
  labelClassName,
}: {
  severity: RiskSeverity;
  label?: string;
  labelClassName?: string;
}) {
  const { bg, border } = riskSeverityCardClass[severity];

  return (
    <div
      className={cn(
        'text-chariot-text-primary relative z-10 flex h-full shrink-0 items-center rounded-3xl border',
        border,
        bg
      )}
    >
      {label && (
        <div
          className={cn(
            'flex h-full shrink-0 items-center justify-center border-r p-2 text-xs font-bold text-nowrap',
            'risk-severity-value',
            border,
            labelClassName
          )}
        >
          {label}
        </div>
      )}
      <div className="flex size-full w-[80px] items-center justify-center p-2 text-xs font-bold">
        {SeverityDef[severity]}
      </div>
    </div>
  );
}
